/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import GridView from '@/views/GridView';
import StringCell from '@/backgrid/StringCell';
import { DateCell } from '@/backgrid/MomentCell';
import IntegerCell from '@/backgrid/IntegerCell';
import { IntegerSortValue } from '@/backgrid/IntegerCell/IntegerCell';
import ButtonLinkCell from '@/backgrid/ButtonLinkCell';
import PageableCollection from '@/backbone/PageableCollection';

const AWPackageDashboardGridView = GridView.extend({
  options: {
    pageSize: 15
  },

  initialize() {
    this.options.columns = [
      {
        name: 'awPackageId',
        label: 'AW Package ID',
        cell: IntegerCell,
        headerCell: 'custom',
        width: 10,
        editable: false,
        sortValue: IntegerSortValue
      },
      {
        name: 'assignedCRS',
        label: 'Assigned CRS',
        cell: StringCell,
        headerCell: 'custom',
        width: 12,
        editable: false
      },
      {
        name: 'assignedEPC',
        label: 'Assigned EPC',
        cell: StringCell,
        headerCell: 'custom',
        width: 12,
        editable: false
      },
      {
        name: 'orderType',
        label: 'Order Type',
        cell: StringCell,
        headerCell: 'custom',
        width: 14,
        editable: false
      },
      {
        name: 'awPackageStatus',
        label: 'Status',
        cell: StringCell,
        headerCell: 'custom',
        width: 10,
        editable: false
      },
      {
        name: 'deviceCount',
        label: '# Devices',
        cell: IntegerCell,
        headerCell: 'custom',
        width: 8,
        editable: false,
        sortValue: IntegerSortValue
      },
      {
        name: 'regionGroup',
        label: 'Region Group',
        cell: StringCell,
        headerCell: 'custom',
        width: 8,
        editable: false
      },
      {
        name: 'popStartDate',
        label: 'POP Start Date',
        cell: DateCell,
        headerCell: 'custom',
        width: 10,
        editable: false
      },
      {
        name: 'createdOn',
        label: 'Created On',
        cell: DateCell,
        headerCell: 'custom',
        width: 10,
        editable: false,
        direction: 'ascending'
      },
      {
        name: '',
        label: '',
        width: 8,
        editable: false,
        sortable: false,
        cell: ButtonLinkCell.extend({
          name: 'Open',
          buttonClass: 'btn-sm btn-outline-primary',
          href(model) {
            return `#aw-package/${model.get('awPackageId')}`;
          },
          newTab: true
        })
      }
    ];
    this.collection = new PageableCollection([], {
      pageSize: this.options.pageSize
    });
    this.options.emptyText = 'No AW Packages Found';
    GridView.prototype.initialize?.apply(this, this.options);
  }
});
export default AWPackageDashboardGridView;
